// Narrow a free-form string (an <select>'s value or a URL search param) into a
// known enum member, or undefined when it's empty / unrecognised. Lets route
// search() handlers and form draft state stay strongly typed without `as never`.
//
// Usage:
//   const status = oneOf(e.target.value, ["pending", "earned", "approved", "paid"] as const);

export function oneOf<T extends string>(value: string, allowed: readonly T[]): T | undefined {
  if (!value) return undefined;
  return (allowed as readonly string[]).includes(value) ? (value as T) : undefined;
}
